import { handleActions } from 'redux-actions';
import {
    formBuilderLoaded,
    formUpdated,
    formChangeSection,
    formBuilderUnload,
    formSaved,
    formUpdateFieldIndex,
} from '../actions';

const initialState = {
    form: {
        id: '',
        name: '',
        sections: [],
    },
    activeSection: -1,
    lastSavedForm: {
        id: '',
        name: '',
        sections: [],
    },
    multipleFieldIndex: -1,
    currentFieldIndex: -1,
};

export default handleActions(
    {
        [formBuilderLoaded]: (state, action) => ({
            ...state,
            ...action.payload,
        }),
        [formUpdated]: (state, action) => ({
            ...state,
            form: action.payload,
        }),
        [formChangeSection]: (state, action) => ({
            ...state,
            ...action.payload,
        }),
        [formUpdateFieldIndex]: (state, action) => ({
            ...state,
            ...action.payload,
        }),
        [formSaved]: (state, action) => ({
            ...state,
            lastSavedForm: action.payload,
            form: action.payload,
        }),
        [formBuilderUnload]: () => initialState,
    },
    initialState,
);
